export default __webpack_public_path__ + "static/media/laari.32a2b2ec.png";